<template>
  <v-container>
    <v-layout row wrap justify-space-around>
      <v-flex xs12 style="margin:10px">
        <v-card class>
          <v-card-title primary-title class="text-xs-center" style="background-color: white">
            <v-spacer></v-spacer>
            <div class="headline">
              <img style="width:100%;" src="@/assets/logo_flow_simulation_game_by_AGILEA.png">
            </div>
            <v-spacer></v-spacer>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex
        v-for="(item, index) in menu"
        :key="index"
        xs12
        sm6
        md4
        lg3
        style="padding: 10px; cursor:pointer;"
        @click.stop="$router.push(item.link)"
      >
        <v-card class="primary" style="color: white">
          <v-card-title primary-title class="text-xs-center" style="padding-bottom: 0px">
            <v-spacer></v-spacer>
            <v-icon color x-large style="font-size: 5rem">{{item.icon}}</v-icon>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text style="text-align: center; padding-top: 0">
            <h3 style="font-size: 20px;margin: 10px;">{{item.title}}</h3>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: "Accueil",
  data() {
    return {
      items: [
        { icon: "videogame_asset", title: "Parties", link: "/games" },
        { icon: "list", title: "Versions du jeu", link: "/game-versions" },
        { icon: "supervisor_account", title: "Utilisateurs", link: "/users" },
        { icon: "settings", title: "Paramètres", link: "/admin" },
      ]
    };
  },
  computed: {
    menu () {
      return this.$store.getters['interfaceSettings/filteredMenu'].filter((item) => item.home === true)
    }
  }
};
</script>
